import { useContext } from 'react';
import { FamilyAllowanceChartsDataContext } from '../contexts/FamilyAllowanceChartContext';

export const useFamilyAllowanceChartsDataContext = () => {
    return useContext(FamilyAllowanceChartsDataContext);
};
